const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "Sahas";
const APP_NAME = process.env.REACT_APP_APP_NAME || `${BRAND_NAME} Smart Studies`;

const APPLICATION_CONSTANTS = {
    KEY_DEVICE_FINGER_PRINT: "Device-Finger-Print",
    KEY_DEVICE_DESCRIPTION: "Device-Description",
    KEY_AUTHENTICATION_TOKEN: "Authentication-Token",
    KEY_GUEST_TOKEN: "Guest-Token",
    BRAND_NAME,
    APP_NAME,
    REGEX_EMAIL: /^[a-zA-Z0-9._%+-]+@(gmail\.com|yahoo\.com|hotmail\.com|icloud\.com)$/,
    REGEX_PHONE: /^[6-9]\d{9}$/,
    EMPTY_VALUE: "--",
    TASK_PRIORITIES: [
        { label: "P0", id: 0 },
        { label: "P1", id: 1 },
        { label: "P2", id: 2 },
        { label: "P3", id: 3 },
        { label: "P4", id: 4 },
    ],
    PAYMENT_TYPES: ["CASH", "NET_BANKING", "UPI", "CHEQUE", "SCH", "DIS"],
    ENROLLMENT_HANDLERS: ["SAHAS INSTITUTE", "DEEP INSTITUTE"],
    NOTE_TYPES: ["NEGATIVE", "POSITIVE"],
    MEDIA_TYPES: ["VIDEO", "PDF", "AUDIO", "ZOOM"],
    AUTHORITIES: {
        // User Management
        MANAGE_OTHER_USERS: "MANAGE_OTHER_USERS",
        USE_CONTAINER_MANAGE_USERS: "USE_CONTAINER_MANAGE_USERS",
        USE_PAGE_USERS: "USE_PAGE_USERS",
        USE_CONTAINER_USER: "USE_CONTAINER_USER",
        READ_USER: "READ_USER",
        CREATE_USER: "CREATE_USER",
        UPDATE_USER: "UPDATE_USER",
        WRITE_USER_BASICS: "WRITE_USER_BASICS",
        READ_USER_BASICS: "READ_USER_BASICS",
        READ_USER_INQUIRIES: "READ_USER_INQUIRIES",
        READ_USER_ENROLLMENTS: "READ_USER_ENROLLMENTS",
        UPDATE_USER_ENROLLMENTS: "UPDATE_USER_ENROLLMENTS",

        USE_PAGE_INQUIRIES: "USE_PAGE_INQUIRIES",

        READ_USER_STREAMING_DEVICES: "READ_USER_STREAMING_DEVICES",
        READ_USER_DEVICES: "READ_USER_DEVICES",
        READ_USER_WALLET: "READ_USER_WALLET",
        READ_USER_WALLET_TRANSACTIONS: "READ_USER_WALLET_TRANSACTIONS",
        READ_USER_GLOBAL_NOTES: "READ_USER_GLOBAL_NOTES",
        READ_USER_COUNSELING_NOTES: "READ_USER_COUNSELING_NOTES",
        READ_USER_ROLES: "READ_USER_ROLES",
        CREATE_USER_ROLES: "CREATE_USER_ROLES",
        DELETE_USER_ROLES: "DELETE_USER_ROLES",
        READ_USER_ENROLLMENT_COURSES: "READ_USER_ENROLLMENT_COURSES",
        READ_USER_CHAPTERS_TEST_CATALOGUE: "READ_USER_CHAPTERS_TEST_CATALOGUE",

        // Course Management
        MANAGE_COURSES: "MANAGE_COURSES",
        CREATE_COURSE: "CREATE_COURSE",
        UPDATE_COURSE: "UPDATE_COURSE",
        DELETE_COURSE: "DELETE_COURSE",
        READ_COURSE: "READ_COURSE",
        UPDATE_COURSE_VIEW_INDEX: "UPDATE_COURSE_VIEW_INDEX",

        UPDATE_COURSE_SUBJECT: "UPDATE_COURSE_SUBJECT",
        CREATE_COURSE_SUBJECT: "CREATE_COURSE_SUBJECT",
        DELETE_COURSE_SUBJECT: "DELETE_COURSE_SUBJECT",
        UPDATE_COURSE_SUBJECT_VIEW_INDEX: "UPDATE_COURSE_SUBJECT_VIEW_INDEX",
        CREATE_COURSE_SUBJECTS: "CREATE_COURSE_SUBJECTS",
        ASSIGN_COURSE_SUBJECT: "ASSIGN_COURSE_SUBJECT",

        // Course Category
        READ_COURSE_CATEGORY: "READ_COURSE_CATEGORY",
        CREATE_COURSE_CATEGORY: "CREATE_COURSE_CATEGORY",
        DELETE_COURSE_CATEGORY: "DELETE_COURSE_CATEGORY",
        UPDATE_COURSE_CATEGORY: "UPDATE_COURSE_CATEGORY",
        UPDATE_COURSE_CATEGORY_VIEW_INDEX: "UPDATE_COURSE_CATEGORY_VIEW_INDEX",
        READ_COURSE_BY_CATEGORY: "READ_COURSE_BY_CATEGORY",

        // Subject Management
        UPDATE_SUBJECTS: "UPDATE_SUBJECTS",
        READ_SUBJECTS: "READ_SUBJECTS",
        READ_SUBJECTS_CHAPTERS: "READ_SUBJECTS_CHAPTERS",

        // Chapter Management
        CREATE_CHAPTERS: "CREATE_CHAPTERS",
        UPDATE_CHAPTERS: "UPDATE_CHAPTERS",
        DELETE_CHAPTERS: "DELETE_CHAPTERS",
        READ_CHAPTERS: "READ_CHAPTERS",
        READ_CHAPTERS_TEST: "READ_CHAPTERS_TEST",
        READ_CHAPTERS_MEDIA: "READ_CHAPTERS_MEDIA",
        UPDATE_CHAPTERS_VIEW_INDEXES: "UPDATE_CHAPTERS_VIEW_INDEXES",

        // Media Management
        CREATE_MEDIA: "CREATE_MEDIA",
        UPDATE_MEDIA: "UPDATE_MEDIA",
        DELETE_MEDIA: "DELETE_MEDIA",
        READ_MEDIA: "READ_MEDIA",
        READ_MEDIA_UPDATE: "READ_MEDIA_UPDATE",
        UPDATE_MEDIA_VIEW_INDEX: "UPDATE_MEDIA_VIEW_INDEX",

        // Enrollment Management
        CREATE_ENROLLMENT: "CREATE_ENROLLMENT",
        UPDATE_ENROLLMENT: "UPDATE_ENROLLMENT",
        READ_ENROLLMENT_TRANSACTION: "READ_ENROLLMENT_TRANSACTION",
        READ_ENROLLMENT_COURSE: "READ_ENROLLMENT_COURSE",
        READ_ENROLLMENT_SUMMARY: "READ_ENROLLMENT_SUMMARY",
        CREATE_ENROLLMENT_TRANSACTION: "CREATE_ENROLLMENT_TRANSACTION",
        CREATE_ENROLLMENT_COURSE: "CREATE_ENROLLMENT_COURSE",
        DELETE_ENROLLMENT_COURSE: "DELETE_ENROLLMENT_COURSE",

        // Inquiry Management
        MANAGE_USER_INQUIRIES: "MANAGE_USER_INQUIRIES",
        CREATE_INQUIRY: "CREATE_INQUIRY",
        UPDATE_INQUIRY: "UPDATE_INQUIRY",
        DELETE_INQUIRY: "DELETE_INQUIRY",
        CREATE_INQUIRY_NOTE: "CREATE_INQUIRY_NOTE",
        DELETE_INQUIRY_NOTE: "DELETE_INQUIRY_NOTE",
        READ_INQUIRY_NOTE: "READ_INQUIRY_NOTE",

        // Wallet Management
        CREATE_WALLET_TRANSACTION: "CREATE_WALLET_TRANSACTION",

        // User Device Management
        UPDATE_USER_DEVICE: "UPDATE_USER_DEVICE",
        MANAGE_USER_STREAMING_DEVICES: "MANAGE_USER_STREAMING_DEVICES",

        // Coupon Code Management
        READ_COUPON_CODE: "READ_COUPON_CODE",
        CREATE_COUPON_CODE: "CREATE_COUPON_CODE",
        UPDATE_COUPON_CODE: "UPDATE_COUPON_CODE",
        DELETE_COUPON_CODE: "DELETE_COUPON_CODE",
        CREATE_COUPON_CODE_COURSES: "CREATE_COUPON_CODE_COURSES",
        DELETE_COUPON_CODE_COURSES: "DELETE_COUPON_CODE_COURSES",
        UPDATE_COUPON_CODE_COURSES: "UPDATE_COUPON_CODE_COURSES",

        // Chapter Types Management
        CREATE_CHAPTER_TYPES: "CREATE_CHAPTER_TYPES",
        UPDATE_CHAPTER_TYPES: "UPDATE_CHAPTER_TYPES",
        DELETE_CHAPTER_TYPES: "DELETE_CHAPTER_TYPES",
        UPDATE_CHAPTER_TYPES_VIEW_INDEXES: "UPDATE_CHAPTER_TYPES_VIEW_INDEXES",

        // Role Management
        CREATE_ROLES: "CREATE_ROLES",
        UPDATE_ROLES: "UPDATE_ROLES",
        DELETE_ROLES: "DELETE_ROLES",
        READ_ROLES_AUTHORITIES: "READ_ROLES_AUTHORITIES",
        CREATE_ROLES_AUTHORITIES: "CREATE_ROLES_AUTHORITIES",
        DELETE_ROLES_AUTHORITIES: "DELETE_ROLES_AUTHORITIES",

        // Authority Management
        CREATE_AUTHORITIES: "CREATE_AUTHORITIES",
        DELETE_AUTHORITIES: "DELETE_AUTHORITIES",

        // Feature Carousel
        CREATE_CAROUSEL: "CREATE_CAROUSEL",
        DELETE_CAROUSEL: "DELETE_CAROUSEL",

        // Page Access
        USE_EMPLOYEE_CORNER: "USE_EMPLOYEE_CORNER",
        USE_ADMIN_CORNER: "USE_ADMIN_CORNER",
        USE_DEVELOPER_CORNER: "USE_DEVELOPER_CORNER",
        USE_PAGE_MY_EXPENSES: "USE_PAGE_MY_EXPENSES",
        USE_PAGE_MANAGE_EXAMS: "USE_PAGE_MANAGE_EXAMS",
        CREATE_EXAM_SERIES: "CREATE_EXAM_SERIES",
        UPDATE_EXAM_SERIES: "UPDATE_EXAM_SERIES",
        CREATE_EXAM: "CREATE_EXAM",
        UPDATE_EXAM: "UPDATE_EXAM",
        DELETE_EXAM: "DELETE_EXAM",
        CREATE_EXAM_QUESTION: "CREATE_EXAM_QUESTION",
        UPDATE_EXAM_QUESTION: "UPDATE_EXAM_QUESTION",
        DELETE_EXAM_QUESTION: "DELETE_EXAM_QUESTION",
        MANAGE_EXAM_ENROLLMENTS: "MANAGE_EXAM_ENROLLMENTS",
        USE_PAGE_MANAGE_BATCHES: "USE_PAGE_MANAGE_BATCHES",
        CREATE_BATCH: "CREATE_BATCH",
        UPDATE_BATCH: "UPDATE_BATCH",
        DELETE_BATCH: "DELETE_BATCH",
        ASSIGN_BATCH_STUDENT: "ASSIGN_BATCH_STUDENT",
        MANAGE_BATCH_ATTENDANCE: "MANAGE_BATCH_ATTENDANCE",
        MANAGE_BATCH_CONTROLLER: "MANAGE_BATCH_CONTROLLER",
        USE_PAGE_MANAGE_EVENTS: "USE_PAGE_MANAGE_EVENTS",
        CREATE_BATCH_EVENT: "CREATE_BATCH_EVENT",
        UPDATE_BATCH_EVENT: "UPDATE_BATCH_EVENT",
        DELETE_BATCH_EVENT: "DELETE_BATCH_EVENT",
        USE_PAGE_MANAGE_NOTIFICATIONS: "USE_PAGE_MANAGE_NOTIFICATIONS",
        CREATE_NOTIFICATION: "CREATE_NOTIFICATION",
        READ_NOTIFICATION: "READ_NOTIFICATION",
        USE_PAGE_TASKS: "USE_PAGE_TASKS",
        CREATE_USER_TASK: "CREATE_USER_TASK",
        READ_ALL_USER_TASKS: "READ_ALL_USER_TASKS",
        DELETE_USER_TASK: "DELETE_USER_TASK",
        USE_PAGE_MANAGE_BRANCHES: "USE_PAGE_MANAGE_BRANCHES",
        CREATE_BRANCH: "CREATE_BRANCH",
        UPDATE_BRANCH: "UPDATE_BRANCH",
        DELETE_BRANCH: "DELETE_BRANCH",
        USE_PAGE_MANAGE_STREAMING_DEVICES_REQUESTS: "USE_PAGE_MANAGE_STREAMING_DEVICES_REQUESTS",
        USE_PAGE_FINANCIALS: "USE_PAGE_FINANCIALS",
        USE_PAGE_ANALYTICS: "USE_PAGE_ANALYTICS",
        USE_PAGE_CHAPTERIZATION: "USE_PAGE_CHAPTERIZATION",
        USE_PAGE_COUPON_CODES: "USE_PAGE_COUPON_CODES",
        USE_PAGE_WEBSITE_MANAGEMENT: "USE_PAGE_WEBSITE_MANAGEMENT",
        USE_PAGE_CALENDAR_SETTINGS: "USE_PAGE_CALENDAR_SETTINGS",

        //Global Notes
        CREATE_GLOBAL_NOTE: "CREATE_GLOBAL_NOTE",
        READ_GLOBAL_NOTE: "READ_GLOBAL_NOTE",
        UPDATE_GLOBAL_NOTE: "UPDATE_GLOBAL_NOTE",
        DELETE_GLOBAL_NOTE: "DELETE_GLOBAL_NOTE",

        // Counseling Notes
        CREATE_COUNSELING_NOTE: "CREATE_COUNSELING_NOTE",
        READ_COUNSELING_NOTE: "READ_COUNSELING_NOTE",
        UPDATE_COUNSELING_NOTE: "UPDATE_COUNSELING_NOTE",
        DELETE_COUNSELING_NOTE: "DELETE_COUNSELING_NOTE",

        CREATE_POLICY: "CREATE_POLICY",
        UPDATE_POLICY: "UPDATE_POLICY",
        DELETE_POLICY: "DELETE_POLICY",
        UPDATE_POLICY_VIEW_INDEX: "UPDATE_POLICY_VIEW_INDEX",

        CREATE_STREAM_SELECTION_TEST_QUESTION: "CREATE_STREAM_SELECTION_TEST_QUESTION",
        UPDATE_STREAM_SELECTION_TEST_QUESTION: "UPDATE_STREAM_SELECTION_TEST_QUESTION",
        DELETE_STREAM_SELECTION_TEST_QUESTION: "DELETE_STREAM_SELECTION_TEST_QUESTION",

        CREATE_STREAM_SELECTION_TEST_INVITE: "CREATE_STREAM_SELECTION_TEST_INVITE",
        DELETE_STREAM_SELECTION_TEST_INVITE: "DELETE_STREAM_SELECTION_TEST_INVITE",
        UPDATE_STREAM_SELECTION_TEST_INVITE: "UPDATE_STREAM_SELECTION_TEST_INVITE",

        CREATE_STREAM_SELECTION_QUESTION_CATEGORY: "CREATE_STREAM_SELECTION_QUESTION_CATEGORY",
        UPDATE_STREAM_SELECTION_QUESTION_CATEGORY: "UPDATE_STREAM_SELECTION_QUESTION_CATEGORY",
        DELETE_STREAM_SELECTION_QUESTION_CATEGORY: "DELETE_STREAM_SELECTION_QUESTION_CATEGORY",
    },
    RUPEE: " ₹",
    EMPTY_EXAM_QUESTION: {
        question: "",
        choice_one: "",
        choice_two: "",
        choice_three: "",
        choice_four: "",
        correct_choice: "",
        media_url: null,
    },
};

module.exports = APPLICATION_CONSTANTS;
